<template>
  <label class="customCheckbox">
    <input
      class="customCheckbox-input"
      type="checkbox"
      :checked="value"
      :disabled="disabled"
      @change="$emit('input', $event.target.checked)"
    >
    <span class="customCheckbox-control" />
    <span class="customCheckbox-text">
      <slot />
      <span class="customCheckbox-hint">{{ hint }}</span>
    </span>
  </label>
</template>

<script>
  export default {
    props: {
      value: Boolean,
      disabled: Boolean,
      hint: String,
    },
  };
</script>

<style>
  .customCheckbox {
    display: inline-block;
    margin-bottom: 16px;
    font-size: 14px;
  }
  .customCheckbox-input {
    position: absolute;
    visibility: hidden;
  }
  .customCheckbox-control {
    display: inline-block;
    vertical-align: text-bottom;
    margin-bottom: 2px;
    width: 16px;
    height: 16px;
    background: white;
    border: 2px solid #999999;
  }
  .customCheckbox-input:checked ~ .customCheckbox-control::before {
    content: '';
    display: block;
    margin: 3px;
    width: 6px;
    height: 6px;
    background: #999999;
  }
  .customCheckbox-input:disabled ~ * {
    opacity: .5;
  }
  .customCheckbox-text {
    margin-left: 12px;
  }
  .customCheckbox-hint {
    display: block;
    margin-left: 32px;
    margin-top: 8px;
    margin-bottom: 8px;
    color: #A7A7A7;
  }
</style>
